import {useState, useEffect} from 'react';
import { searchOnEnter, searchOrReset } from '../../components/searchOnEnter';
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import MetaData from '../../layouts/MetaData';
import Loader from '../../layouts/Loader';
import { useDispatch, useSelector} from 'react-redux';
import {Form, InputGroup, DropdownButton, Dropdown, ProgressBar } from 'react-bootstrap';

import { 
    getPatients, 
    updatePatientConsentStatus, 
    searchPatient, 
    patientDeActivate,
    patientReactivate,
    getDoctors,
    getHrLists,
    filterPatientByAccStatus,
    getDoctorsPatientList,
    getNurseAssignedPatientsList,
} from '../../actions/adminActions';

import { Link } from 'react-router-dom';
import { useAlert } from 'react-alert';
import { Table } from 'react-bootstrap';
import moment from 'moment';
import IncludeDeactivatedToggle from '../../components/IncludeDeactivatedToggle';
import ReactivatePatientModal from '../../components/ReactivatePatientModal';
import DeactivatePatientModal from '../../components/DeactivatePatientModal';
import { isDeceasedPatient, isSuperAdmin } from '../../utils/deactivationReasons';
import { canReactivatePatient } from '../../utils/patientStatus';
import Pagination from 'react-js-pagination';
import {UPDATE_PATIENT_RESET} from '../../constants/adminConstants';
import { formatClinicianName } from '../../utils/clinicianName';
import CareTeamBulkBar from '../../components/CareTeam/CareTeamBulkBar';
import { applyCareTeamFilter } from '../../components/CareTeam/careTeamText';
import { useSortableTable, SortableTh } from '../../components/SortableTable';
import { PATIENT_SORT_COLUMNS } from './CCMPatients';
import { formatDate, formatDob } from '../../utils/dateFormat';


const PATIENT_PAGE_SIZE = 50;
const STAFF_LIST_SIZE = 1000;

const PatientsList = () => {

    const dispatch = useDispatch();
    let compliantStatus; // variable to store compliant status of patient

    const [smShow, setSmShow] = useState(false); //small confirm modal
    const [deactivateTarget, setDeactivateTarget] = useState(null);
    const [patientModel, setPatientModel] = useState(null);
    const [doctorId, setDoctorId] = useState('');
    const [hrId, setHrId] = useState('');
    const [sortPatientByAccount, setSortPatientByAccount] = useState('');

    const alert = useAlert();
    const { loading, error, patients, isUpdated} = useSelector(state => state.admin);
    const { doctors } = useSelector(state => state.doctor);
    const { hrs} = useSelector(state => state.hrslist);
    const { totalPatients, inactivePatients } = useSelector(state => state.adminStat);
    const [keyword, setKeyword] = useState('');
    const [searchBy ,setSearchBy] = useState('emrId');
    const [isSearch, setIsSearch] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [resPerPage, setResPerPage] = useState(PATIENT_PAGE_SIZE);
    const [includeDeactivated, setIncludeDeactivated] = useState(false);
    const [reactivateTarget, setReactivateTarget] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);
    const [careFilter, setCareFilter] = useState('');
    const { user } = useSelector(state => state.auth);
    const listTotal = includeDeactivated ? (totalPatients || 0) + (inactivePatients || 0) : totalPatients;

    const tableSort = useSortableTable(patients, {
        id: 'admin.rpmPatients',
        columns: { ...PATIENT_SORT_COLUMNS, lastReading: { type: 'date', value: (p) => p?.lastReading } },
        defaultSort: { key: 'name', dir: 'asc' },
    });
    const careRows = applyCareTeamFilter(tableSort.rows, careFilter);
    const toggleSelected = (id) => setSelectedIds((ids) => (ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]));
    const allVisibleSelected = careRows.length > 0 && careRows.every((p) => selectedIds.includes(p?._id));
    const toggleAllVisible = () => setSelectedIds(allVisibleSelected ? selectedIds.filter((id) => !careRows.some((p) => p?._id === id)) : [...new Set([...selectedIds, ...careRows.map((p) => p?._id)])]);
    const listSort = tableSort.sortKey && !['provider', 'lastReading'].includes(tableSort.sortKey) ? { sortBy: tableSort.sortKey, sortDir: tableSort.sortDir } : null;

    useEffect(() =>{
        if(error){
            alert.error(error); return;
        }

        if(isUpdated){
            alert.success('Status Changed');
            dispatch({type: UPDATE_PATIENT_RESET});
            dispatch(getPatients(resPerPage, currentPage, includeDeactivated, listSort));
            setSmShow(false);
        }

        dispatch(getPatients(resPerPage, currentPage, includeDeactivated, listSort));
        dispatch(getDoctors(STAFF_LIST_SIZE, 1));
        dispatch(getHrLists(STAFF_LIST_SIZE, 1));

    }, [dispatch, alert, error, isUpdated, currentPage, includeDeactivated, tableSort.sortKey, tableSort.sortDir]);


        const searchPatientByDoctor = (id) => {
            if(id === "undefined" || ''){
                dispatch(getPatients(resPerPage, currentPage, includeDeactivated, listSort));
                dispatch(getDoctors(STAFF_LIST_SIZE, 1));
                dispatch(getHrLists(STAFF_LIST_SIZE, 1));
                return
            }
            dispatch(getDoctorsPatientList(id, includeDeactivated));
        }

        const searchPatientByHR = (id) => {
            if(id === "undefined" || ''){
                dispatch(getPatients(resPerPage, currentPage, includeDeactivated, listSort));
                dispatch(getDoctors(STAFF_LIST_SIZE, 1));
                dispatch(getHrLists(STAFF_LIST_SIZE, 1));
                return
            }
            dispatch(getNurseAssignedPatientsList(id, includeDeactivated));
            setDoctorId('');
        }

        const searchPatientByAccount = (key) => {
            if(key === 'undefined'){
                return
            }
            
            dispatch(filterPatientByAccStatus(key))
        }
       

    const changeConsentStatus = (id, value) => {
        dispatch(updatePatientConsentStatus(id, value));
        alert.success('Status Changed');
    }

    function setCurrentPageNumber(pageNumber) {
        setCurrentPage(pageNumber);
    }

    const searchhandler = () => {
        dispatch(searchPatient(searchBy, keyword));
    }  

    const deActivatePatient = (deactivation) => {
        dispatch(patientDeActivate(patientModel, deactivation));
            setSmShow(false);
    }

    const reactivatePatient = (reason, confirmDeceased) => {
        dispatch(patientReactivate(reactivateTarget?._id, reason, confirmDeceased));
        setReactivateTarget(null);
    }

    const refreshHandler = () => {
        dispatch(getPatients(resPerPage, currentPage, includeDeactivated, listSort));
        dispatch(getDoctors(STAFF_LIST_SIZE, 1));
        dispatch(getHrLists(STAFF_LIST_SIZE, 1));
        setHrId('');
        setDoctorId('');
        setKeyword('');
    }

    function calculateCompliancyStatus(date) {  
        var m = moment(date);
        var today = moment().startOf('day');
        var days = moment.duration(today - m).asDays();

        switch(true){
            case (days >= 0 && days < 3):
                compliantStatus = 'compliant'
                break;

            case (days >= 3 && days <= 7):
                compliantStatus = "mostLikelyCompliant"
                break;

            case (days >= 8 && days <= 20):
                compliantStatus = "notLikelyCompliant"
                break;

            case (days >= 8 && days <= 31):
                compliantStatus = "nonCompliant"
                break;
            
            default:
                compliantStatus = 'nonCompliant'
                break;
        }
    }


    return (
        <>
                <MetaData title="RPM Patients"/>
                <Sidebar />    

                <section className="home-section">
                {/* TopBar */}
                <TopBar />

                {loading ? <Loader /> : (
                <>   
                {/*  patients List Filter Section */}
                <div className="shadow-lg p-3 mb-5 mr-4 ml-4 rounded-card" style={{backgroundColor: '#FAFAFA'}}>
                    <div className="home-content">
                        
                        <div className="row-display">
                            <div className="col-md-7">
                                <h5 style={{color: '#004aad'}}>
                                    <i className="bx bx-user"></i> <strong>&nbsp;Active RPM Patients </strong>
                                </h5>
                            </div>

                            <Link to="/adminDashboard" className="btn btn-secondary btn-sm"><i className='bx bx-arrow-back' ></i></Link> &nbsp;
                            <button className="btn btn-secondary btn-sm" onClick={refreshHandler}><i className='bx bx-refresh'></i></button> &nbsp;
                            <Link to ="/Patients/Inactive" className="edit-pill">
                                <i className='bx bxs-user'></i> &nbsp;Inactive Patients
                            </Link>
                            <Link to="/addpatient" className="edit-pill">
                                <i className='bx bxs-user'></i> &nbsp;Add New Patient
                            </Link>                           
                        </div>
                        <hr />

                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row-display">
                                    
                                        <select 
                                            className="form-control select-input-type" 
                                            value={searchBy}
                                            onChange={e => setSearchBy(e.target.value)}
                                            >
                                                <option value="undefined">Filter Patient </option>
                                                <option value="emrId">EHR-ID</option>
                                                <option value="firstname">Firstname</option>
                                                <option value="lastname">Lastname</option>
                                                <option value="email">email</option>
                                                <option value="phone1">phone1</option>
                                                <option value="initialsetup">Initial Month</option>
                                                <option value="diseases">Diseases</option>
                                                <option value="insurancecompany">Ins. Company</option>
                                                <option value="address">Address</option>
                                                <option value="state">State</option>
                                                <option value="city">City</option>
                                                <option value="zipCode">Zip Code</option>
                                        </select>    
                                            &nbsp;
                                            <InputGroup>
                                                    <Form.Control
                                                        placeholder="Search here ..."
                                                        aria-label="Search here ..."
                                                        className="form-control"
                                                        value={keyword}
                                                        onChange={e => setKeyword(e.target.value) }
                                                        onKeyDown={searchOnEnter(searchhandler, refreshHandler)}
                                                    />
                                                    &nbsp;<button className="btn btn-outline-primary btn-sm" 
                                                        id="button-addon2" onClick={() => searchOrReset(keyword, searchhandler, refreshHandler)}>
                                                        <i className='bx bx-search-alt'></i>
                                                    </button>
                                            </InputGroup>
                                            </div>
                                        </div>

                                <div className="col-md-6">
                                    <div className="row-display">
                                    <IncludeDeactivatedToggle checked={includeDeactivated} onChange={setIncludeDeactivated} />
                                    &nbsp;&nbsp;
                                    {/* Sort By Acc Status, doctor not assigned, nurse not assigned */}

                                    <div>
                                        <select 
                                        value={sortPatientByAccount}
                                        onChange={e => searchPatientByAccount(e.target.value)}
                                        className="form-control">
                                            <option value="undefined"> Device Status.</option>
                                            <option value="nonCompliant">Pts with no device</option>                                                
                                        </select>    
                                    </div>
                                    &nbsp;&nbsp;
                                    {/* Sort by Doctor */}
                                    <div>
                                            <select 
                                            className="form-control"
                                            value={doctorId}
                                            onChange={(e) => {searchPatientByDoctor(e.target.value); setDoctorId(e.target.value)}}
                                            >
                                                <option value="undefined"> Sort By Physician.</option>
                                                {doctors && doctors.map((doc, index) => (
                                                    <option value={doc?._id} key={index}>{formatClinicianName(doc)}</option>                                         
                                                ))}
                                            </select>    
                                    </div>
                                    &nbsp;&nbsp;

                                    {/* Sort By Nurse */}
                                    <div>
                                        <select 
                                                className="form-control"
                                                value={hrId}
                                                onChange={(e) => {searchPatientByHR(e.target.value); setHrId(e.target.value)}} 
                                                >
                                                    <option value="undefined">Sort By Nurse</option>
                                                    {hrs && hrs.map((hr, index) => (
                                                        <option value={hr?._id} key={index}> {hr?.firstname} {hr?.lastname}</option>
                                                    ))}
                                                    
                                        </select>    
                                    </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>  
                    <br />


                    {/* Patient List Card */}
                        <div className="col-md-12">
                        {patients && <>
                            <CareTeamBulkBar selectedIds={selectedIds} filter={careFilter} onFilterChange={setCareFilter} defaultSlot="rpm" onClear={() => setSelectedIds([])} onDone={() => { setSelectedIds([]); dispatch(getPatients(resPerPage, currentPage, includeDeactivated, listSort)); }} />
                            <Table responsive hover striped bordered>
                            <thead align="center">
                                <tr>
                                <th><input type="checkbox" aria-label="Select all patients" checked={allVisibleSelected} onChange={toggleAllVisible} /></th>
                                <SortableTh sortKey="emrId" sort={tableSort}>EHR-ID</SortableTh>
                                <SortableTh sortKey="name" sort={tableSort}>Name</SortableTh>
                                <SortableTh sortKey="dob" sort={tableSort}>DOB</SortableTh>
                                <th>Device Status</th>
                                <SortableTh sortKey="status" sort={tableSort}>Acc Status</SortableTh>
                                <SortableTh sortKey="provider" sort={tableSort} className="text-nowrap">Provider</SortableTh>
                                <th>Compliancy Status</th>
                                <SortableTh sortKey="lastReading" sort={tableSort}>Last Reading</SortableTh>
                                <SortableTh sortKey="consent" sort={tableSort}>Consent Role</SortableTh>
                                <th style={{width: '60px'}}></th>
                                </tr>
                            </thead>
                            <tbody>
                            
                            {patients && patients.length > 0 ? <> 
                                {careRows.map((patient, index) => (
                                <tr key={index}>
                                <td><input type="checkbox" aria-label={`Select ${patient?.lastname}, ${patient?.firstname}`} checked={selectedIds.includes(patient?._id)} onChange={() => toggleSelected(patient?._id)} /></td>
                                <td>
                                    {patient?.emrId || 'N/A'}
                                </td>
                                <td>
                                    <Link className="link" 
                                        to={{ pathname: "/patientProfile", state: {patientid: patient?._id, batterySignalStatus: patient?.batterySignals?.sig}}}>
                                        {patient?.lastname}, {patient?.firstname}
                                    </Link>
                                </td>
                                
                                <td> {formatDob(patient?.DOB)} 
                                    
                                </td> 
                                
                                <td>{patient?.batterySignals?.sig >= 0 && patient?.batterySignals?.sig <= 10 ? 
                                        <text style={{color: 'red', fontWeight: 'bold'}}>Weak</text> : patient?.batterySignals?.sig > 10 && patient?.batterySignals?.sig <= 20 ? 
                                        <text style={{color: 'orange', fontWeight: 'bold'}}>Medium</text> : patient?.batterySignals?.sig > 20 ? <text style={{color: 'green', fontWeight: 'bold'}}>Strong</text> : '--'} 

                                    {patient?.batterySignals?.sig ? <ProgressBar variant="success" now={patient?.batterySignals?.bat} label={`${patient?.batterySignals?.bat}%`} /> : '--'}
                                </td>
                                
                                <td style={{color: 'green', fontWeight: 'bold'}}>
                                   {patient?.block === false ? <span style={{color: 'green', fontWeight: 'bold'}}>Active</span> : <span style={{color: 'red', fontWeight: 'bold'}}>Deactivated</span>}{isDeceasedPatient(patient) && <span className="badge bg-dark text-white ml-1">Deceased</span>}
                                </td> 
                                    
                                {patient?.assigned_doctor_id ? <>
                                <td className="text-nowrap">{formatClinicianName(patient?.assigned_doctor_id)}</td>
                                </> : <>
                                <td>---</td>
                                </>}

                                {calculateCompliancyStatus(patient?.lastReading)}    
                        
                                <td>
                                    {patient?.lastReading ? 
                                        compliantStatus === 'compliant' ? <p style={{color: 'green', fontWeight: 'bold'}}>
                                            Compliant</p> : compliantStatus === 'mostLikelyCompliant' ? <p style={{color: '#F95800', fontWeight: 'bold'}}>
                                                Most Likely Compliant</p> : compliantStatus === 'notLikelyCompliant' ? <p style={{color: 'dodgerblue', fontWeight: 'bold'}}>
                                                    Not Likely Compliant</p> : compliantStatus === 'nonCompliant' ? <p style={{color: 'red', fontWeight: 'bold'}}>
                                                    Non Compliant</p> : null : '--'}
                                </td>

                                <td><span style={{fontWeight: 'bold'}}>{patient?.lastReading ? formatDate(patient?.lastReading) : '--'}</span>
                                </td>

                                <td>{patient?.patientType}</td>
                                
                                {/* Actions */}
                                <td>
                                <DropdownButton id="dropdown-basic-button" variant="link">
                                    <Dropdown.Item>
                                        <Link className="link" to={{ pathname: "/patientProfile", state: {patientid: patient?._id, batterySignalStatus: patient?.batterySignals?.sig}}}>View Profile</Link>
                                    </Dropdown.Item>

                                    <Dropdown.Item>
                                        <Link className="link" to={{pathname: '/Patients/Edit', state: {patientDetails: patient}}}>Edit Details</Link>
                                    </Dropdown.Item>

                                    <Dropdown.Item>
                                        {patient?.block === true ? (canReactivatePatient(user?.role) && <span className="link" style={{color: 'green', cursor: 'pointer'}} onClick={() => setReactivateTarget(patient)}>Reactivate Profile</span>)
                                        : <Link className="link" style={{color: 'red'}} to="/patients" onClick={() => {setSmShow(true); setPatientModel(patient?._id); setDeactivateTarget(patient)}}>Deactivate Profile</Link>}
                                    </Dropdown.Item>
                                </DropdownButton>
                                </td>
                            </tr>    
                            ))}
                            </> : <div>
                                <small className="not-found-text">Patients Not Found</small>
                            </div> }
                            
                            </tbody>
                            
                            </Table>
                            <small style={{color: 'gray'}}>{PATIENT_PAGE_SIZE} patients per page — click a column header to sort</small> 

                            {/* Pagination */}
                                {!isSearch && !doctorId && !hrId && resPerPage <= listTotal && (
                                    <div className="d-flex justify-content-center mt-5"> 
                                    <Pagination activePage={currentPage} 
                                    itemsCountPerPage={resPerPage} 
                                    totalItemsCount = {listTotal}
                                    onChange={setCurrentPageNumber} 
                                    nextPageText = {'⟩'}
                                    prevPageText = {'⟨'}
                                    firstPageText = {'«'}
                                    lastPageText = {'»'}
                                    itemClass='page-item'
                                    linkClass="page-link"
                                    />           
                            </div>
                                )}    

                                <DeactivatePatientModal
                                    show={smShow}
                                    patient={deactivateTarget}
                                    onCancel={() => setSmShow(false)}
                                    onConfirm={deActivatePatient}
                                />

                                <ReactivatePatientModal
                                    show={!!reactivateTarget}
                                    patientName={reactivateTarget?.lastname}
                                    deceased={isDeceasedPatient(reactivateTarget)}
                                    canOverrideDeceased={isSuperAdmin(user)}
                                    onCancel={() => setReactivateTarget(null)}
                                    onConfirm={reactivatePatient}
                                />
                        </>}                      
                        </div>
                    </div>
                </>
            )}
            </section>
        </>
    )
}

export default PatientsList
